/* BASCAR — winkelwagen
   1. Winkelwagenlade (CartDrawer) na 'In winkelwagen' op de productpagina,
      met de voortgang naar gratis bezorging, alle regels, een opmerking,
      het totaal en Afrekenen.
   2. Snelknop op de productkaarten (wandpanelen, shoppagina).
   3. Aantal aanpassen vanuit de lade zelf.
   4. Winkelwagenpagina werkt bij zonder de pagina te herladen.
   Werkt de JavaScript niet, dan doen de kaarten, het formulier en
   de winkelwagen gewoon weer wat ze altijd deden.

   De lade volgt CartDrawer uit het designsysteem BASCAR Experience
   Evolution en gebruikt de klassen bx-cart* uit snippets/bascar-tokens.liquid
   (niet bx-drawer: die naam is van het mobiele menu in de header). */
(function () {
  var CART_URL = '/cart';
  var panel = null;
  var lastTrigger = null;

  /* Gratis bezorging vanaf dit bedrag, in centen. Houd het gelijk aan
     'Gratis bezorging vanaf' in de sectie BASCAR winkelwagen; de lade kan die
     instelling op andere pagina's niet lezen. 0 zet de voortgangsbalk uit. */
  var GRATIS_BEZORGING_VANAF = 75000;

  var CSS = [
    /* lade */
    '.bcadd__scrim{position:fixed;top:0;right:0;bottom:0;left:0;z-index:60;background:rgba(26,18,8,.35);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:0;transition:opacity var(--bx-slow) var(--bx-ease)}',
    '.bcadd__scrim.is-open{opacity:1}',
    /* Dawn verbergt elke lege div; de achtergrondlaag is met opzet leeg.
       Twee klassen wegen zwaarder dan die regel. */
    '.bcadd__scrim.bcadd__scrim{display:block}',
    /* De lade zweeft met 12px ruimte rondom en heeft vier ronde hoeken. */
    '.bcadd{position:fixed;top:12px;right:12px;bottom:12px;z-index:61;font-family:var(--font-sans);color:var(--ink-soft);transform:translateX(calc(100% + 24px));transition:transform var(--bx-slow) var(--bx-ease)}',
    '.bcadd.bx-cart{height:auto;max-width:calc(100% - 24px);border-radius:var(--radius-lg);overflow:hidden}',
    '.bcadd.is-open{transform:translateX(0)}',
    '.bcadd .bcadd__titel{margin:0}',
    '.bcadd .bcadd__titel:focus{outline:none}',
    '.bcadd .bcadd__aantal{display:inline;font-family:var(--font-sans)}',
    '.bcadd .bcadd__melding{display:flex;align-items:flex-start;gap:8px;margin:0;font-size:14px;line-height:1.5;color:var(--ink)}',
    '.bcadd .bcadd__melding svg{flex:none;width:18px;height:18px;color:var(--gold)}',
    '.bcadd .bcadd__regels{display:grid;gap:var(--space-5)}',
    '.bcadd .bcadd__regel+.bcadd__regel{padding-top:var(--space-5);border-top:1px solid var(--line)}',
    '.bcadd .bcadd__regel .bx-media{padding:4px;font-size:11px;line-height:1.3;text-align:center}',
    '.bcadd .bcadd__info{display:flex;flex-direction:column;align-items:flex-start;gap:4px;min-width:0}',
    '.bcadd .bcadd__naam{margin:0;font-size:15px;font-weight:500;line-height:1.35;color:var(--ink)}',
    '.bcadd .bcadd__info .bx-badge{margin-top:var(--space-2)}',
    '.bcadd .bx-qty span{line-height:34px}',
    '.bcadd .bx-qty button[disabled]{opacity:.35;cursor:default}',
    '.bcadd .bx-qty button:focus-visible{outline:2px solid var(--gold);outline-offset:-2px}',
    '.bcadd .bcadd__prijs{font-size:15px;white-space:nowrap}',
    '.bcadd .bcadd__excl{margin:-8px 0 0;text-align:right}',
    '.bcadd .bcadd__links{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:var(--space-3)}',
    '.bcadd button.bx-link{background:none;border-top:0;border-right:0;border-left:0;padding:0 0 2px;cursor:pointer}',
    '.bcadd .bcadd__trust{display:flex;flex-wrap:wrap;justify-content:center;gap:var(--space-2) var(--space-5);font-size:12px;color:var(--ink-muted)}',
    '.bcadd .bcadd__trust span{display:inline-flex;align-items:center;gap:6px}',
    '.bcadd .bcadd__trust svg{width:16px;height:16px}',
    '.bcadd .bcadd__keuze{display:grid;gap:var(--space-3)}',
    '.bcadd .bx-chip[disabled]{opacity:.4;cursor:default;text-decoration:line-through}',
    '.bcadd .bx-error{align-items:flex-start;margin:0;font-size:14px;line-height:1.5}',
    '.bcadd .bx-error svg{margin-top:2px}',
    /* lege winkelwagen en verwijderen */
    '.bcadd .bcadd__leeg{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;gap:var(--space-4);padding:var(--space-10) var(--space-4);text-align:center}',
    '.bcadd .bcadd__leeg .bx-h2{margin:0}',
    '.bcadd .bcadd__leeg p{margin:0;max-width:32ch}',
    '.bcadd .bcadd__weg{margin-top:var(--space-2);padding:0;font:inherit;font-size:13px;color:var(--ink-muted);background:none;border:0;border-bottom:1px solid var(--line-control);cursor:pointer}',
    '.bcadd .bcadd__weg:hover{color:var(--ink)}',
    '.bcadd .bcadd__weg:focus-visible{outline:2px solid var(--gold);outline-offset:2px}',
    '@media screen and (max-width:749px){.bcadd{top:8px;right:8px;bottom:8px;left:8px}.bcadd.bx-cart{width:auto;max-width:none}}',
    /* snelknop op de kaarten */
    '.bqa{position:absolute;right:14px;bottom:14px;z-index:2;display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:var(--surface);color:var(--ink);box-shadow:var(--shadow-card);cursor:pointer;opacity:0;transform:translateY(8px);transition:opacity var(--bx-slow) var(--bx-ease),transform var(--bx-slow) var(--bx-ease),background var(--bx-fast) var(--bx-ease),color var(--bx-fast) var(--bx-ease)}',
    '.bqa:hover{background:var(--action);color:var(--on-action)}',
    '.bqa:focus-visible{outline:2px solid var(--gold);outline-offset:2px}',
    '.bqa[disabled]{opacity:.5;cursor:default}',
    '.bgrid__card:hover .bqa,.bpro__card:hover .bqa,.bqa:focus-visible{opacity:1;transform:translateY(0)}',
    '@media (hover:none){.bqa{opacity:1;transform:translateY(0)}}',
    /* winkelwagenpagina tijdens het bijwerken */
    '.bcart.is-busy{opacity:.5;pointer-events:none;transition:opacity .2s ease}',
    '@media (prefers-reduced-motion:reduce){.bcadd,.bcadd__scrim,.bqa{transition:none}}',
  ].join('');

  /* Lijniconen van 1,5px, zoals in snippets/bascar-icon.liquid. */
  function icoon(pad) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      pad +
      '</svg>'
    );
  }

  var ICOON = {
    sluiten: icoon('<path d="M6 6l12 12M18 6 6 18"/>'),
    vinkje: icoon('<path d="M5 12.5l4.5 4.5L19 7.5"/>'),
    schild: icoon('<path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z"/>'),
    pijl: icoon('<path d="M5 12h14M13 6l6 6-6 6"/>'),
    fout: icoon('<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/>'),
  };

  var CART_ICON =
    '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">' +
    '<path d="M6 8h12l-1 12H7L6 8z"/><path d="M9.5 8V6.5a2.5 2.5 0 0 1 5 0V8"/></svg>';

  /* ---------- btw: weergave voor particulier of zakelijk ---------- */

  /* De bezoeker kiest rechtsboven of hij prijzen inclusief of exclusief btw
     wil zien. Alleen het gekozen bedrag is zichtbaar; het andere bedrag
     tonen wij nergens meer. Er verandert niets aan wat Shopify afrekent; de
     kassa is altijd inclusief btw.

     Alle bedragen staan in de opmaak als centen inclusief btw:
       data-btw-prijs  het bedrag, in de gekozen weergave
       data-btw-excl   het andere bedrag; staat nog in de opmaak, maar is
                       overal verborgen (zie bbtw-stijl hieronder)
       data-btw-label  'incl. btw' of 'excl. btw' bij het bedrag
     De rekenhulp gebruikt dezelfde functies; dit bestand laadt eerder. */
  window.BascarBtw =
    window.BascarBtw ||
    (function () {
      var TARIEF = 0.21;
      var SLEUTEL = 'bascar-btw';
      var modus = 'particulier';

      /* Particulier is de standaard: wie nog nooit heeft gekozen, ziet
         prijzen inclusief btw. Alleen een eigen keuze zet dat om. De oude
         waarde 'excl' uit de eerste versie van deze knop laten we vervallen,
         zodat niemand onbedoeld op zakelijk binnenkomt. */
      try {
        if (window.localStorage.getItem(SLEUTEL) === 'zakelijk') modus = 'zakelijk';
      } catch (e) {}

      function formatteer(centen, valuta) {
        var bedrag = (Number(centen) || 0) / 100;
        try {
          return new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: valuta || 'EUR',
          }).format(bedrag);
        } catch (e) {
          return '€ ' + bedrag.toFixed(2).replace('.', ',');
        }
      }

      function zonderBtw(inclCenten) {
        return Math.round((Number(inclCenten) || 0) / (1 + TARIEF));
      }

      /* Het bedrag zoals de bezoeker het wil zien. */
      function centen(inclCenten) {
        var n = Number(inclCenten) || 0;
        return modus === 'zakelijk' ? zonderBtw(n) : n;
      }

      function geld(inclCenten, valuta) {
        return formatteer(centen(inclCenten), valuta);
      }

      function label() {
        return modus === 'zakelijk' ? 'excl. btw' : 'incl. btw';
      }

      /* Het andere bedrag, voor de kleine regel eronder. */
      function tweedeTekst(inclCenten, valuta) {
        var n = Number(inclCenten) || 0;
        return modus === 'zakelijk'
          ? formatteer(n, valuta) + ' incl. btw'
          : formatteer(zonderBtw(n), valuta) + ' excl. btw';
      }

      function naam() {
        return modus === 'zakelijk' ? 'Zakelijk' : 'Particulier';
      }

      function pasToe(root) {
        var bereik = root || document;

        bereik.querySelectorAll('[data-btw-prijs]').forEach(function (el) {
          el.textContent = geld(el.getAttribute('data-btw-prijs'), el.getAttribute('data-btw-valuta'));
        });

        bereik.querySelectorAll('[data-btw-excl]').forEach(function (el) {
          el.textContent = tweedeTekst(el.getAttribute('data-btw-excl'), el.getAttribute('data-btw-valuta'));
        });

        bereik.querySelectorAll('[data-btw-label]').forEach(function (el) {
          el.textContent = label();
        });

        bereik.querySelectorAll('[data-btw-modus-naam]').forEach(function (el) {
          el.textContent = naam();
        });

        bereik.querySelectorAll('[data-btw-knop]').forEach(function (knop) {
          var aan = knop.getAttribute('data-btw-knop') === modus;
          knop.classList.toggle('is-gekozen', aan);
          knop.setAttribute('aria-checked', aan ? 'true' : 'false');
        });
      }

      function zet(nieuw) {
        modus = nieuw === 'zakelijk' ? 'zakelijk' : 'particulier';
        try {
          window.localStorage.setItem(SLEUTEL, modus);
        } catch (e) {}
        pasToe(document);
        document.dispatchEvent(new CustomEvent('bascar:btw', { detail: { modus: modus } }));
      }

      if (!document.getElementById('bbtw-stijl')) {
        var stijl = document.createElement('style');
        stijl.id = 'bbtw-stijl';
        stijl.textContent =
          '.bbtw-excl{display:block;margin:-18px 0 20px;text-align:right;font-size:12.5px;letter-spacing:0;text-transform:none;color:var(--ink-muted)}' +
          '[data-btw-excl],[data-bcfg-out-excl],.bbtw-excl{display:none!important}';
        (document.head || document.documentElement).appendChild(stijl);
      }

      /* De keuzeknop staat in de kop van de pagina; die bouwt zijn eigen
         markup. Wij luisteren hier, zodat elke pagina dezelfde keuze deelt. */
      document.addEventListener('click', function (e) {
        var knop = e.target.closest && e.target.closest('[data-btw-knop]');
        if (!knop) return;
        e.preventDefault();
        zet(knop.getAttribute('data-btw-knop'));
      });

      pasToe(document);

      return {
        modus: function () {
          return modus;
        },
        formatteer: formatteer,
        zonderBtw: zonderBtw,
        centen: centen,
        geld: geld,
        label: label,
        naam: naam,
        tweedeTekst: tweedeTekst,
        pasToe: pasToe,
        zet: zet,
      };
    })();

  function injectStyles() {
    if (document.getElementById('bcadd-styles')) return;
    var style = document.createElement('style');
    style.id = 'bcadd-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.bhdr__cart').forEach(function (link) {
      var href = link.getAttribute('href');
      if (href !== CART_URL && href !== '/cart') return;
      var badge = link.querySelector('.bhdr__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'bhdr__cart-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  /* ---------- paneel ---------- */

  function close() {
    if (!panel) return;
    panel.scrim.classList.remove('is-open');
    panel.box.classList.remove('is-open');
    document.body.style.overflow = '';
    var scrim = panel.scrim;
    var box = panel.box;
    panel = null;
    window.setTimeout(function () {
      scrim.remove();
      box.remove();
    }, 420);
    if (lastTrigger) lastTrigger.focus();
  }

  function build() {
    injectStyles();
    if (panel) return panel.box;

    var scrim = document.createElement('div');
    scrim.className = 'bcadd__scrim';
    scrim.addEventListener('click', close);

    var box = document.createElement('aside');
    box.className = 'bcadd bx-cart';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'bcadd-titel');

    document.body.appendChild(scrim);
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';

    window.requestAnimationFrame(function () {
      scrim.classList.add('is-open');
      box.classList.add('is-open');
    });

    panel = { scrim: scrim, box: box };
    return box;
  }

  /* Kop van de lade: titel en sluiten. De focus springt naar de titel. */
  function header(titel) {
    return (
      '<div class="bx-cart__head">' +
      '<h2 class="bx-h3 bcadd__titel" id="bcadd-titel" tabindex="-1">' +
      titel +
      '</h2>' +
      '<button class="bx-icon-btn" type="button" data-bcadd-close aria-label="Sluiten">' +
      ICOON.sluiten +
      '</button>' +
      '</div>'
    );
  }

  function wire(box) {
    box.querySelectorAll('[data-bcadd-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    var titel = box.querySelector('.bcadd__titel');
    if (titel) titel.focus();
  }

  function aantalTekst(cart) {
    return (
      'Uw winkelwagen <span class="bx-small bcadd__aantal" data-bcadd-aantal>(' +
      cart.item_count +
      ')</span>'
    );
  }

  /* Maatwerk uit de configurator: de wand en de diensten die erbij horen.
     Het aantal volgt uit de maten, dus daar staan geen plus en min bij. */
  function isMaatwerk(props) {
    return !!(props && (props._panelen || props._montagedienst || props._inmeetdienst));
  }

  function regelHtml(item, valuta) {
    var props = item.properties || {};
    var maatwerk = isMaatwerk(props);
    /* Montage en inmeten horen bij de wand eronder en gaan mee als die
       wand wordt verwijderd; ze hebben daarom geen eigen knop. */
    var dienst = !!(props._montagedienst || props._inmeetdienst);
    var beeld = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="" width="144" height="144">'
      : 'Foto komt later';

    var details = '';
    /* Bij montage en inmeten is de variantnaam een prijsstap ('€ 325'). Die
       tonen wij niet: het echte bedrag staat rechts, in de gekozen btw-weergave. */
    if (!dienst && item.variant_title && item.variant_title !== 'Default Title') {
      details += '<p class="bx-small">' + escapeHtml(item.variant_title) + '</p>';
    }
    Object.keys(props).forEach(function (sleutel) {
      var waarde = props[sleutel];
      if (sleutel.charAt(0) === '_' || waarde == null || waarde === '') return;
      details += '<p class="bx-small">' + escapeHtml(sleutel) + ': ' + escapeHtml(waarde) + '</p>';
    });
    if (props._montage) {
      details += '<span class="bx-badge bx-badge--gold">Inclusief montage</span>';
    }

    var aantal = '';
    if (!maatwerk) {
      aantal =
        '<div class="bx-qty">' +
        '<button type="button" data-bcadd-step="-1" aria-label="Aantal verlagen"' +
        (item.quantity <= 1 ? ' disabled' : '') +
        '>&minus;</button>' +
        '<span data-bcadd-qty aria-live="polite">' +
        item.quantity +
        '</span>' +
        '<button type="button" data-bcadd-step="1" aria-label="Aantal verhogen">+</button>' +
        '</div>';
    } else if (props._panelen) {
      aantal =
        '<p class="bx-small">' +
        item.quantity +
        (item.quantity === 1 ? ' paneel' : ' panelen') +
        ', op maat gezaagd</p>';
    }

    return (
      '<div class="bx-line bcadd__regel" data-bcadd-regel="' +
      escapeHtml(item.key) +
      '" data-aantal="' +
      item.quantity +
      '"' +
      (dienst ? ' data-bcadd-dienst' : '') +
      '>' +
      '<span class="bx-media">' +
      beeld +
      '</span>' +
      '<div class="bcadd__info">' +
      '<p class="bcadd__naam">' +
      escapeHtml(item.product_title) +
      '</p>' +
      details +
      aantal +
      (dienst ? '' : '<button type="button" class="bcadd__weg" data-bcadd-weg>Verwijderen</button>') +
      '</div>' +
      '<span class="bx-price bcadd__prijs" data-btw-prijs="' +
      (item.final_line_price != null ? item.final_line_price : item.price * item.quantity) +
      '" data-btw-valuta="' +
      escapeHtml(valuta) +
      '"></span>' +
      '</div>'
    );
  }

  /* ShippingProgress: hoeveel er nog ontbreekt tot gratis bezorging. */
  function voortgangHtml(cart) {
    if (!(GRATIS_BEZORGING_VANAF > 0)) return '';
    var rest = GRATIS_BEZORGING_VANAF - cart.total_price;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price * 100) / GRATIS_BEZORGING_VANAF)));
    var tekst =
      rest <= 0
        ? 'Uw bestelling wordt gratis bezorgd.'
        : 'Nog <strong data-btw-prijs="' +
          rest +
          '" data-btw-valuta="' +
          escapeHtml(cart.currency || '') +
          '" style="font-weight:500;color:var(--ink)"></strong> tot gratis bezorging.';
    return (
      '<div class="bx-progress" data-bcadd-voortgang>' +
      '<span>' +
      tekst +
      '</span>' +
      '<span class="bx-progress__bar" role="progressbar" aria-label="Voortgang naar gratis bezorging" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      pct +
      '"><span style="width:' +
      pct +
      '%"></span></span>' +
      '</div>'
    );
  }

  function regelsHtml(cart) {
    var valuta = cart.currency || '';
    return cart.items
      .map(function (row) {
        return regelHtml(row, valuta);
      })
      .join('');
  }

  /* Zet na een wijziging alleen de regels, de voortgang en de bedragen
     opnieuw neer. De opmerking blijft staan zoals de klant hem typte. */
  function werkLadeBij(box, cart) {
    var regels = box.querySelector('[data-bcadd-regels]');
    if (regels) regels.innerHTML = regelsHtml(cart);

    var voortgang = box.querySelector('[data-bcadd-voortgang]');
    if (voortgang) voortgang.outerHTML = voortgangHtml(cart);

    var aantal = box.querySelector('[data-bcadd-aantal]');
    if (aantal) aantal.textContent = '(' + cart.item_count + ')';

    var totalEl = box.querySelector('[data-bcadd-total]');
    if (totalEl) totalEl.setAttribute('data-btw-prijs', cart.total_price);

    var exclEl = box.querySelector('[data-bcadd-excl]');
    if (exclEl) exclEl.setAttribute('data-btw-excl', cart.total_price);

    window.BascarBtw.pasToe(box);
    updateHeaderCount(cart.item_count);
  }

  /* plus en min in de lade: past de regel in de winkelwagen meteen aan */
  function wireQty(box) {
    if (box.dataset.bcaddPlusMin === 'true') return;
    box.dataset.bcaddPlusMin = 'true';
    var busy = false;

    box.addEventListener('click', function (event) {
      /* Verwijderen: aantal op 0. Is de winkelwagen daarna leeg, dan toont de
         lade de lege versie. */
      var weg = event.target.closest && event.target.closest('[data-bcadd-weg]');
      if (weg && !busy) {
        var wegRegel = weg.closest('[data-bcadd-regel]');
        if (!wegRegel) return;

        /* De regel zelf, plus de diensten die er direct boven staan. Shopify
           zet regels die samen zijn toegevoegd in omgekeerde volgorde: eerst
           inmeten en montage, dan de wand. */
        var updates = {};
        updates[wegRegel.getAttribute('data-bcadd-regel')] = 0;
        var vorige = wegRegel.previousElementSibling;
        while (vorige && vorige.hasAttribute('data-bcadd-dienst')) {
          updates[vorige.getAttribute('data-bcadd-regel')] = 0;
          vorige = vorige.previousElementSibling;
        }

        busy = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            if (cart.item_count === 0) {
              updateHeaderCount(0);
              showEmpty();
            } else {
              werkLadeBij(box, cart);
            }
          })
          .catch(function () {})
          .then(function () {
            busy = false;
          });
        return;
      }

      var btn = event.target.closest && event.target.closest('[data-bcadd-step]');
      if (!btn || btn.disabled || busy) return;

      var regel = btn.closest('[data-bcadd-regel]');
      if (!regel) return;

      var key = regel.getAttribute('data-bcadd-regel');
      var stap = btn.getAttribute('data-bcadd-step');
      var next = parseInt(regel.getAttribute('data-aantal'), 10) + parseInt(stap, 10);
      if (next < 1) return;

      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          werkLadeBij(box, cart);

          /* De knoppen zijn opnieuw getekend; zet de focus terug op dezelfde. */
          var nieuw = null;
          box.querySelectorAll('[data-bcadd-regel]').forEach(function (r) {
            if (r.getAttribute('data-bcadd-regel') === key) nieuw = r;
          });
          var knop = nieuw && nieuw.querySelector('[data-bcadd-step="' + stap + '"]');
          if (knop && !knop.disabled) knop.focus();
        })
        .catch(function () {})
        .then(function () {
          busy = false;
        });
    });
  }

  /* De opmerking gaat mee naar de winkelwagen, net als op de pagina /cart.
     Klikt de klant meteen op Afrekenen, dan bewaren we eerst. */
  function wireNote(box) {
    var note = box.querySelector('[data-bcadd-note]');
    if (!note) return;
    var bewaard = note.value;

    function bewaar() {
      if (note.value === bewaard) return Promise.resolve();
      var waarde = note.value;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: waarde }),
      })
        .then(function () {
          bewaard = waarde;
        })
        .catch(function () {});
    }

    note.addEventListener('change', bewaar);

    box.querySelectorAll('[data-bcadd-door]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (note.value === bewaard) return;
        event.preventDefault();
        bewaar().then(function () {
          window.location.href = link.getAttribute('href');
        });
      });
    });
  }

  /* Toont de hele winkelwagen. Met een item erbij (net toegevoegd) staat er
     bovenaan een melding; zonder item is de lade geopend via het icoon. */
  function showItem(item, cart) {
    if (!cart.item_count) {
      showEmpty();
      return;
    }

    var box = build();
    var valuta = escapeHtml(cart.currency || '');
    var melding = item
      ? '<p class="bcadd__melding" role="status">' +
        ICOON.vinkje +
        '<span>' +
        escapeHtml(item.product_title) +
        ' is toegevoegd.</span></p>'
      : '';

    box.innerHTML =
      header(aantalTekst(cart)) +
      '<div class="bx-cart__body">' +
      melding +
      voortgangHtml(cart) +
      '<div class="bcadd__regels" data-bcadd-regels>' +
      regelsHtml(cart) +
      '</div>' +
      '<label class="bx-field">' +
      '<span class="bx-label">Opmerking bij uw bestelling</span>' +
      '<textarea class="bx-textarea" rows="3" data-bcadd-note placeholder="Bijvoorbeeld: parkeren achter het huis">' +
      escapeHtml(cart.note || '') +
      '</textarea>' +
      '</label>' +
      '</div>' +
      '<div class="bx-cart__foot">' +
      '<div class="bx-summary__total">' +
      '<span class="bx-label">Totaal <span data-btw-label>incl. btw</span></span>' +
      '<b data-bcadd-total data-btw-prijs="' +
      cart.total_price +
      '" data-btw-valuta="' +
      valuta +
      '"></b>' +
      '</div>' +
      '<p class="bx-small bcadd__excl" data-bcadd-excl data-btw-excl="' +
      cart.total_price +
      '" data-btw-valuta="' +
      valuta +
      '"></p>' +
      '<a class="bx-btn bx-btn--block" href="/checkout" data-bcadd-door>Afrekenen</a>' +
      '<div class="bcadd__links">' +
      '<a class="bx-link" href="' +
      CART_URL +
      '" data-bcadd-door>Naar de winkelwagen</a>' +
      '<button class="bx-link" type="button" data-bcadd-close>Verder winkelen</button>' +
      '</div>' +
      '<div class="bcadd__trust">' +
      '<span>' +
      ICOON.schild +
      'Veilig betalen</span>' +
      '<span>' +
      ICOON.vinkje +
      'Montage door ons eigen team</span>' +
      '</div>' +
      '</div>';

    window.BascarBtw.pasToe(box);
    wire(box);
    wireQty(box);
    wireNote(box);
  }

  /* Lege winkelwagen: een uitnodiging, geen excuus. */
  function showEmpty() {
    var box = build();
    box.innerHTML =
      header('Uw winkelwagen') +
      '<div class="bx-cart__body bcadd__leeg">' +
      '<h3 class="bx-h2">Uw winkelwagen is nog leeg</h3>' +
      '<p class="bx-body">Kies uw houtsoort en vul de maten van uw wand in. Wij zagen alles op maat en monteren de wand bij u.</p>' +
      '<a class="bx-btn" href="/pages/wandpanelen">Stel uw wand samen</a>' +
      '<button class="bx-link" type="button" data-bcadd-close>Verder kijken</button>' +
      '</div>';
    wire(box);
  }

  /* Het winkelwagenicoon in de kop opent de lade in plaats van de pagina
     /cart. Op de pagina /cart zelf, en met Ctrl of Cmd ingedrukt, gaat de
     link gewoon door. */
  function openCart(trigger) {
    lastTrigger = trigger || null;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        showItem(null, cart);
      })
      .catch(function () {
        window.location.href = CART_URL;
      });
  }

  function initCartIcon() {
    if (document.documentElement.dataset.bcaddIcon === 'true') return;
    document.documentElement.dataset.bcaddIcon = 'true';

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a.bhdr__cart');
      if (!link) return;
      var href = link.getAttribute('href');
      if (href !== CART_URL && href !== '/cart') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      if (window.location.pathname === CART_URL) return;
      event.preventDefault();
      openCart(link);
    });
  }

  function showError(message) {
    var box = build();
    box.innerHTML =
      header('Niet gelukt') +
      '<div class="bx-cart__body">' +
      '<p class="bx-error" role="alert">' +
      ICOON.fout +
      '<span>' +
      escapeHtml(message) +
      '</span></p>' +
      '</div>' +
      '<div class="bx-cart__foot">' +
      '<button class="bx-btn bx-btn--secondary bx-btn--block" type="button" data-bcadd-close>Sluiten</button>' +
      '</div>';
    wire(box);
  }

  /* ---------- toevoegen ---------- */

  function refreshAndShow(item) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        showItem(item, cart);
      });
  }

  function addVariant(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(
            result.data.description ||
              result.data.message ||
              'Dit product kon niet worden toegevoegd.'
          );
          return null;
        }
        return refreshAndShow(result.data);
      });
  }

  /* ---------- keuzepaneel voor producten met varianten ---------- */

  function showChooser(product) {
    var box = build();
    var image = product.featured_image
      ? '<img src="' + escapeHtml(product.featured_image) + '" alt="" width="200" height="200">'
      : '';

    var optionName = product.options && product.options[0];
    if (optionName && typeof optionName === 'object') optionName = optionName.name;
    if (!optionName) optionName = 'Uitvoering';

    var startIndex = 0;
    product.variants.forEach(function (variant, index) {
      if (startIndex === 0 && !product.variants[0].available && variant.available) {
        startIndex = index;
      }
    });

    var options = product.variants
      .map(function (variant, index) {
        return (
          '<button class="bx-chip' +
          (index === startIndex ? ' is-active' : '') +
          '" type="button" aria-pressed="' +
          (index === startIndex ? 'true' : 'false') +
          '" data-bcadd-variant="' +
          variant.id +
          '" data-price="' +
          variant.price +
          '"' +
          (variant.available ? '' : ' disabled') +
          '>' +
          escapeHtml(variant.title) +
          '</button>'
        );
      })
      .join('');

    box.innerHTML =
      header('Kies uw uitvoering') +
      '<div class="bx-cart__body">' +
      '<div class="bx-line bcadd__regel">' +
      '<span class="bx-media">' +
      (image || 'Foto komt later') +
      '</span>' +
      '<div class="bcadd__info">' +
      '<p class="bcadd__naam">' +
      escapeHtml(product.title) +
      '</p>' +
      '</div>' +
      '<span class="bx-price bcadd__prijs" data-bcadd-price data-btw-prijs="' +
      product.variants[startIndex].price +
      '"></span>' +
      '</div>' +
      '<div class="bcadd__keuze">' +
      '<p class="bx-label" id="bcadd-optie">' +
      escapeHtml(optionName) +
      '</p>' +
      '<div class="bx-chips" role="group" aria-labelledby="bcadd-optie">' +
      options +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="bx-cart__foot">' +
      '<button class="bx-btn bx-btn--block" type="button" data-bcadd-confirm>In winkelwagen</button>' +
      '<div class="bcadd__links">' +
      '<a class="bx-link" href="' +
      escapeHtml(product.url) +
      '">Bekijk het product</a>' +
      '<button class="bx-link" type="button" data-bcadd-close>Verder winkelen</button>' +
      '</div>' +
      '</div>';

    var chosen = product.variants[startIndex];
    var priceEl = box.querySelector('[data-bcadd-price]');
    var confirm = box.querySelector('[data-bcadd-confirm]');

    /* De prijs van de eerste keuze meteen tonen, niet pas na een klik. */
    window.BascarBtw.pasToe(box);

    box.querySelectorAll('[data-bcadd-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('[data-bcadd-variant]').forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        chosen = { id: parseInt(btn.dataset.bcaddVariant, 10) };
        if (priceEl) {
          priceEl.setAttribute('data-btw-prijs', parseInt(btn.dataset.price, 10));
          window.BascarBtw.pasToe(box);
        }
      });
    });

    if (confirm) {
      confirm.addEventListener('click', function () {
        confirm.disabled = true;
        confirm.textContent = 'Bezig…';
        addVariant(chosen.id, 1);
      });
    }

    wire(box);
  }

  function quickAdd(handle, button) {
    lastTrigger = button;
    if (button) button.disabled = true;

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('niet gevonden');
        return response.json();
      })
      .then(function (product) {
        var available = product.variants.filter(function (variant) {
          return variant.available;
        });
        if (product.variants.length === 1) {
          return addVariant(product.variants[0].id, 1);
        }
        if (available.length === 1) {
          return addVariant(available[0].id, 1);
        }
        showChooser(product);
      })
      .catch(function () {
        window.location.href = '/products/' + handle;
      })
      .then(function () {
        if (button) button.disabled = false;
      });
  }

  /* ---------- snelknop op de kaarten zetten ---------- */

  var CARDS = [
    { card: '.bgrid__card', media: '.bgrid__media', link: '.bgrid__link' },
    { card: '.bpro__card', media: '.bpro__media', link: '.bpro__card-link' },
  ];

  function handleFromHref(href) {
    if (!href) return null;
    var match = href.split('?')[0].split('#')[0].match(/\/products\/([^/]+)\/?$/);
    return match ? match[1] : null;
  }

  function initQuickAdd() {
    injectStyles();

    CARDS.forEach(function (set) {
      document.querySelectorAll(set.card).forEach(function (card) {
        if (card.dataset.bqaReady === 'true') return;

        var link = card.querySelector(set.link);
        var media = card.querySelector(set.media);
        if (!link || !media) return;

        var handle = handleFromHref(link.getAttribute('href'));
        if (!handle) return;

        card.dataset.bqaReady = 'true';

        var button = document.createElement('button');
        button.className = 'bqa';
        button.type = 'button';
        button.innerHTML = CART_ICON;
        button.setAttribute('aria-label', 'Toevoegen aan winkelwagen');
        button.setAttribute('title', 'Toevoegen aan winkelwagen');

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          quickAdd(handle, button);
        });

        media.appendChild(button);
      });
    });
  }

  /* ---------- winkelwagenpagina zonder herladen ---------- */

  function sectionWrapper() {
    var root = document.querySelector('.bcart');
    if (!root) return null;
    var wrapper = root.closest ? root.closest('.shopify-section') : null;
    if (!wrapper || !wrapper.id) return null;
    return wrapper;
  }

  function changeLine(line, quantity) {
    var wrapper = sectionWrapper();
    var root = document.querySelector('.bcart');
    if (!wrapper || !root) return;

    var id = wrapper.id.replace('shopify-section-', '');
    var noteField = document.querySelector('.bcart__note-field');
    var noteValue = noteField ? noteField.value : null;
    root.classList.add('is-busy');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: id,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('mislukt');
        return response.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);

        var html = cart.sections && cart.sections[id];
        if (!html) throw new Error('geen sectie');

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById(wrapper.id);
        if (!fresh) throw new Error('geen sectie');

        wrapper.innerHTML = fresh.innerHTML;
        window.BascarBtw.pasToe(wrapper);

        if (noteValue != null) {
          var newNote = document.querySelector('.bcart__note-field');
          if (newNote) newNote.value = noteValue;
        }

        initCartPage();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  /* haalt de bestaande luisteraars van de sectie weg door het element
     te vervangen door een kopie; daarna hangen we onze eigen erop */
  function replaceNode(node) {
    var clone = node.cloneNode(true);
    node.parentNode.replaceChild(clone, node);
    return clone;
  }

  function initCartPage() {
    var form = document.querySelector('.bcart__form');
    if (!form || form.dataset.bcartAjax === 'true') return;
    form.dataset.bcartAjax = 'true';

    var checkoutClicked = false;
    var checkoutBtn = form.querySelector('[name="checkout"]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        checkoutClicked = true;
      });
    }

    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (checkoutClicked) return;
      if (submitter && submitter.name === 'checkout') return;
      event.preventDefault();
    });

    var note = form.querySelector('[name="note"]');
    if (note) {
      note.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value }),
        }).catch(function () {});
      });
    }

    var updateBtn = form.querySelector('[name="update"]');
    if (updateBtn) updateBtn.style.display = 'none';

    var rows = form.querySelectorAll('.bcart__item');
    rows.forEach(function (row, index) {
      var line = index + 1;

      row.querySelectorAll('[data-bcart-step]').forEach(function (original) {
        var btn = replaceNode(original);
        btn.addEventListener('click', function () {
          var field = btn.parentNode.querySelector('[data-bcart-qty]');
          if (!field) return;
          var next = parseInt(field.value, 10) + parseInt(btn.dataset.bcartStep, 10);
          if (isNaN(next) || next < 0) next = 0;
          changeLine(line, next);
        });
      });

      var input = row.querySelector('[data-bcart-qty]');
      if (input) {
        var field = replaceNode(input);
        field.addEventListener('change', function () {
          var next = parseInt(field.value, 10);
          if (isNaN(next) || next < 0) next = 0;
          changeLine(line, next);
        });
      }

      var remove = row.querySelector('.bcart__remove');
      if (remove) {
        remove.addEventListener('click', function (event) {
          event.preventDefault();
          changeLine(line, 0);
        });
      }
    });
  }

  /* ---------- productpagina ---------- */

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('bprod__form')) return;
    if (window.location.pathname.indexOf('/cart') === 0) return;

    event.preventDefault();

    var button = form.querySelector('.bprod__add');
    var original = button ? button.textContent : '';
    lastTrigger = button;
    if (button) {
      button.disabled = true;
      button.textContent = 'Bezig…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(
            result.data.description ||
              result.data.message ||
              'Dit product kon niet worden toegevoegd.'
          );
          return null;
        }
        return refreshAndShow(result.data);
      })
      .catch(function () {
        form.submit();
      })
      .then(function () {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && panel) close();
  });

  function boot() {
    window.BascarBtw.pasToe(document);
    initQuickAdd();
    initCartPage();
    initCartIcon();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* de thema-editor bouwt secties opnieuw op */
  document.addEventListener('shopify:section:load', boot);
})();